"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Sum = void 0;
function Sum(collection, getNumberFromItem) {
    if (!collection || collection.length === 0) {
        return 0;
    }
    return collection.map(function (item) { return getNumberFromItem(item); }).reduce(function (total, current) { return (total || 0) + (!current || isNaN(current) ? 0 : current); });
}
exports.Sum = Sum;
